import React, { Fragment } from "react"
import Calendar from "Components/Calendar"

export default function Weibo() {
    return (
        <Fragment>
            <Calendar channelName={"微博"} />
            <div id="board_input_modal" />
        </Fragment>
    )
}
